/**
 * Sidebar menu configuration.
 * Visibility: roles (optional) + module permission (via hasPermission).
 * Parent groups render when at least one child is visible.
 */
export const sidebarMenu = [
  {
    id: "dashboard",
    name: "Dashboard",
    path: "/",
    module: "dashboard",
  },
  {
    id: "organization",
    name: "Organization",
    path: "/company",
    module: "oragnizations",
    children: [
      {
        id: "companies",
        name: "Companies",
        path: "/company",
        module: "company_list",
        roles: ["Admin"],
      },
      {
        id: "employers",
        name: "Employers",
        path: "/employer",
        module: "employer_management",
        roles: ["Admin"],
      },
      {
        id: "departments",
        name: "Departments",
        path: "/departments",
        module: "departments",
        roles: ["Admin", "Employer"],
      },
      {
        id: "designations",
        name: "Designations",
        path: "/designations",
        module: "designations",
        roles: ["Admin", "Employer"],
      },
      {
        id: "org-holidays-employer",
        name: "Organization Holidays",
        path: "/organization-holiday",
        module: "oragnization_holiday_management",
        roles: ["Employer"],
      },
      {
        id: "shift-master",
        name: "Shift Master",
        path: "/shifts",
        module: "shift_master",
        roles: ["Employer"],
      },
      {
        id: "company-settings",
        name: "Company Settings",
        path: "/company-settings",
        module: "company_settings",
        roles: ["Employer"],
      },
    ],
  },
  {
    id: "employees",
    name: "Employees",
    path: "/users",
    module: "employee_management",
    roles: ["Admin", "Employer"],
    children: [
      {
        id: "employee-list",
        name: "Employee List",
        path: "/users",
        module: "employee_list",
        roles: ["Admin", "Employer"],
      },
      {
        id: "assign-shift",
        name: "Assign Shift",
        path: "/assign-shift",
        module: "assign_shift",
        roles: ["Employer"],
      },
    ],
  },
  {
    id: "time-attendance",
    name: "Time & Attendance",
    path: "/time-attendance",
    module: "leave",
    roles: ["Admin", "Employer"],
    children: [
      {
        id: "attendance",
        name: "Attendance",
        path: "/time-attendance",
        module: "attendance_management",
        roles: ["Admin", "Employer"],
      },
      {
        id: "leave-requests",
        name: "Leave Requests",
        path: "/leaves",
        module: "leave_list",
        roles: ["Admin", "Employer"],
      },

      {
        id: "leave-balance-mgmt",
        name: "Leave Balance",
        path: "/leave-balance",
        module: "leave_balance",
        roles: ["Admin", "Employer"],
      },
      {
        id: "holiday-calendar-mgmt",
        name: "Holiday Calendar",
        path: "/holidays",
        module: "holidays",
        roles: ["Admin", "Employer"],
      },
    ],
  },
  {
    id: "my-work",
    name: "My Work",
    path: "/employee_attendance",
    module: "employee_attendance",
    roles: ["Employee"],
    children: [
      {
        id: "my-attendance",
        name: "My Attendance",
        path: "/employee_attendance",
        module: "employee_attendance",
        roles: ["Employee"],
      },
      {
        id: "my-payslips",
        name: "My Payslips",
        path: "/employee_Payslips",
        module: "employee_payslips",
        roles: ["Employee"],
      },
      {
        id: "my-tasks",
        name: "My Tasks",
        path: "/employee_task_issue",
        module: "employee_task_issue",
        roles: ["Employee"],
      },
    ],
  },
  {
    id: "employee-leave",
    name: "Leave",
    path: "/leaves",
    module: "leave",
    roles: ["Employee"],
    children: [
      {
        id: "my-leaves",
        name: "My Leaves",
        path: "/leaves",
        module: "leave_list",
        roles: ["Employee"],
      },
      {
        id: "emp-leave-balance",
        name: "Leave Balance",
        path: "/leave-balance",
        module: "leave_balance",
        roles: ["Employee"],
      },
      {
        id: "emp-holiday-calendar",
        name: "Holiday Calendar",
        path: "/holidays",
        module: "holidays",
        roles: ["Employee"],
      },
    ],
  },
  {
    id: "payroll",
    name: "Payroll",
    path: "/payrolls",
    module: "salaries",
    roles: ["Admin", "Employer"],
    children: [
      {
        id: "payroll-processing",
        name: "Payroll Processing",
        path: "/payrolls",
        module: "payrolls",
        roles: ["Admin", "Employer"],
      },
      {
        id: "payslip-management",
        name: "Payslips",
        path: "/pay-slips",
        module: "pay_slips",
        roles: ["Admin", "Employer"],
      },
      {
        id: "payroll-tax-slab",
        name: "Employee Tax Slab",
        path: "/employeet-tax-slab",
        module: "employee_tax_slab",
        roles: ["Admin", "Employer"],
      },
      {
        id: "reports",
        name: "Reports",
        path: "/reports",
        module: "report_management",
        roles: ["Admin", "Employer"],
      },
    ],
  },
  {
    id: "employee-tax-slab",
    name: "Tax Slab",
    path: "/employeet-tax-slab",
    module: "employee_tax_slab",
    roles: ["Employee"],
  },
  {
    id: "performance",
    name: "Performance",
    path: "/appraisal",
    module: "appraisals",
    children: [
      {
        id: "appraisal-cycles",
        name: "Appraisal Cycles",
        path: "/appraisal",
        module: "appraisal_cycle",
        roles: ["Admin", "Employer"],
      },
      {
        id: "appraisal-reviews",
        name: "Appraisal Reviews",
        path: "/review",
        module: "appraisal_reviews",
      },
    ],
  },
  {
    id: "compliance",
    name: "Compliance",
    path: "/challan-master",
    module: "compliance",
    roles: ["Admin", "Employer"],
    children: [
      {
        id: "challan-master",
        name: "Challan Master",
        path: "/challan-master",
        module: "challan_master",
        roles: ["Admin", "Employer"],
      },
      {
        id: "tax-slab-config",
        name: "Tax Slab Configuration",
        path: "/tax-slab",
        module: "tax_slab",
        roles: ["Admin", "Employer"],
      },
    ],
  },
  {
    id: "documents-contracts",
    name: "Documents & Contracts",
    path: "/documents",
    module: "genrate_documents",
    children: [
      {
        id: "documents",
        name: "Documents",
        path: "/documents",
        module: "genrate_documents",
      },
      {
        id: "terms",
        name: "Terms & Conditions",
        path: "/terms",
        module: "contract_terms_conditions",
        roles: ["Admin"],
      },
      {
        id: "contracts",
        name: "Contracts",
        path: "/contract",
        module: "contract_managment",
        roles: ["Admin"],
      },
    ],
  },
  {
    id: "projects",
    name: "Projects",
    path: "/projects",
    module: "projects",
    roles: ["Admin", "Employer"],
    children: [
      {
        id: "project-list",
        name: "Project List",
        path: "/projects",
        module: "project_list",
        roles: ["Admin", "Employer"],
      },
      {
        id: "tasks-issues",
        name: "Tasks & Issues",
        path: "/tasks",
        module: "task_issues_management",
        roles: ["Admin", "Employer"],
      },
    ],
  },
  {
    id: "masters",
    name: "Master Configuration",
    path: "/roles",
    module: "masters",
    roles: ["Admin"],
    children: [
      {
        id: "roles",
        name: "Role Management",
        path: "/roles",
        module: "roles",
        roles: ["Admin"],
      },
      {
        id: "module-master",
        name: "Module Master",
        path: "/module-master",
        module: "module_master",
        roles: ["Admin"],
      },
      {
        id: "holiday-master",
        name: "Holiday Master",
        path: "/holiday-master",
        module: "holiday_master",
        roles: ["Admin"],
      },
      {
        id: "org-holidays-admin",
        name: "Organization Holidays",
        path: "/organization-holiday",
        module: "oragnization_holiday_management",
        roles: ["Admin"],
      },
      {
        id: "subscription-plans",
        name: "Subscription Plans",
        path: "/plans",
        module: "subscripation_plans",
        roles: ["Admin"],
      },
    ],
  },
  {
    id: "announcements",
    name: "Announcements",
    path: "/announcement",
    module: "notifications",
  },
];

export default sidebarMenu;
